(function () {
  var lastTrigger = null;

  /* The product info column carries Dawn's scroll-trigger animation, which
     applies a transform. A transformed ancestor becomes the containing block
     for position:fixed, so the modal must live directly on <body>. */
  function resolveModal(opener) {
    if (opener.reetSgModal && document.body.contains(opener.reetSgModal)) {
      return opener.reetSgModal;
    }

    var id = opener.getAttribute('data-sg-open');
    var wrap = opener.closest('.pk-sg');
    var modal = (wrap && wrap.querySelector('.pk-sg__modal')) || document.getElementById(id);
    if (!modal) return null;

    // Drop stale copies left behind by a theme editor re-render
    var stale = document.querySelectorAll('body > .pk-sg__modal');
    for (var i = 0; i < stale.length; i++) {
      if (stale[i] !== modal && stale[i].id === id) {
        stale[i].parentNode.removeChild(stale[i]);
      }
    }

    document.body.appendChild(modal);
    opener.reetSgModal = modal;
    return modal;
  }

  function openModal(opener) {
    var modal = resolveModal(opener);
    if (!modal) return;

    modal.hidden = false;
    document.body.classList.add('pk-sg-open');

    requestAnimationFrame(function () {
      modal.classList.add('is-open');
    });

    var closeBtn = modal.querySelector('.pk-sg__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    if (!modal) return;

    modal.classList.remove('is-open');
    document.body.classList.remove('pk-sg-open');

    window.setTimeout(function () {
      modal.hidden = true;
    }, 300);

    if (lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var opener = target.closest('[data-sg-open]');
    if (opener) {
      event.preventDefault();
      lastTrigger = opener;
      openModal(opener);
      return;
    }

    var closer = target.closest('[data-sg-close]');
    if (closer) {
      event.preventDefault();
      closeModal(closer.closest('.pk-sg__modal'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var open = document.querySelector('.pk-sg__modal.is-open');
    if (open) closeModal(open);
  });
})();
